/**
 * @license lucide-vue-next v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const FlagTriangleLeft = createLucideIcon("flag-triangle-left", [
  ["path", { d: "M17 22V2L7 7l10 5", key: "1rmf0r" }]
]);

export { FlagTriangleLeft as default };
//# sourceMappingURL=flag-triangle-left.js.map
